// extracted by mini-css-extract-plugin
export default {"menuItem":"Dashboard_menuItem__cSA0c","dashboardMenuIcon":"Dashboard_dashboardMenuIcon__Ww0Xt"};